import React, { useEffect, useState } from "react";
import AdminLTE, {
  Content,
  Row,
  Col,
  Box,
  Button,
  SimpleTable,
  Pagination,
  Inputs,
} from "adminlte-2-react";
import _ from "lodash";
import moment from "moment";
import controller from "./duck";

import { useSelector, useDispatch } from "react-redux";

const { Text } = Inputs;

function AsistenciasByDate({ history, match }) {
  const dispatch = useDispatch();

  const modelAsistencias = useSelector((state) => state.getAsistenciasByDate);

  const [asistencias, setAsistencias] = useState(null);
  const [totalResults, setTotalResults] = useState(0);
  const [activePage, setActivePage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    const data = modelAsistencias?.data?.data;
    const error = modelAsistencias?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckGetAsistenciasByDate.actions.clear());
    }
    if (data) {
      setAsistencias(data.data.items);
      setTotalResults(data.data.total);

      dispatch(controller.duckGetAsistenciasByDate.actions.clear());
    }
  }, [modelAsistencias]);

  useEffect(() => {
    dispatch(
      controller.getAsistenciasByDateThunk(
        match.params.organizacion,
        match.params.fecha,
        1,
        pageSize
      )
    );
  }, []);

  function handlePage(page) {
    setActivePage(page);
    setAsistencias([]);
    dispatch(
      controller.getContactosThunk(
        match.params.organizacion,
        match.params.fecha,
        page + 1,
        pageSize
      )
    );
  }

  return (
    <Content
      title="Asistencias"
      subTitle="Asistencias"
      browserTitle="Asistencias"
      show={false}
    >
      <Row>
        <Col md="8" mdOffset="2">
          <Box title="Asistencias">
            <div>
              <span>Total: {totalResults}</span>
            </div>
            {asistencias && asistencias.length > 0 ? (
              <SimpleTable
                hover={true}
                data={asistencias.map((row, index) => {
                  return {
                    fecha: moment(row.fecha).format("DD-MM-YYYY HH:mm"),
                    nombre: row.contacto.nombre,
                    documento: row.contacto.documento,
                    valorEntrada: row.valorEntrada
                      ? row.valorEntrada
                      : "Sin entrada",
                    reserva: row.reserva ? (
                      <a
                        style={{
                          cursor: "pointer",
                        }}
                        onClick={() => history.push(`/reserva/${row.reserva}`)}
                      >
                        {row.reserva}
                      </a>
                    ) : "Sin reserva",
                  };
                })}
                columns={[
                  { title: "Fecha", data: "fecha" },
                  { title: "Nombre", data: "nombre" },
                  { title: "Documento", data: "documento" },
                  { title: "Entrada", data: "valorEntrada" },
                  { title: "Reserva", data: "reserva" },
                ]}
              />
            ) : (
              <h4>No se han encontrado asistencias</h4>
            )}
            <Pagination
              activePage={activePage}
              pageSize={pageSize}
              totalElements={totalResults}
              onChange={handlePage}
              labels={{
                first: "Primera",
                last: "Última",
                previous: "Anterior",
                next: "Siguiente",
              }}
            />
            <div>
              <span>Total: {totalResults}</span>
            </div>
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default AsistenciasByDate;
